// Dependencias
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../../services/AxiosInstance';
import { initMercadoPago, Wallet } from '@mercadopago/sdk-react';
import { useTranslation } from 'react-i18next';

// Componentes
import BannerFichas from '../../../components/BannerFichas/BannerFichas';
import Navbar from '../../../components/Navbar/Navbar';
import SessionBar from '../../../components/SessionBar/SessionBar';
import Footer from '../../../components/Footer/Footer';

// Funciones
import { ROUTES } from '../../../const/routes';
import { useUser } from '../../../context/UserContext';

const EleccionCargaSaldo = () => {
  const [preferenceId, setPreferenceId] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userData, isLoading } = useUser();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [monto, setMonto] = useState(null);
  const montoValido =
    monto == 1000 ||
    monto == 2000 ||
    monto == 5000 ||
    monto == 10000 ||
    monto == 20000 ||
    monto == 50000;

  const isMercadoPagoInitialized = useRef(false);
  const hasAttemptedCreation = useRef(false);

  const createPreference = async (amountParam) => {
    try {
      const response = await axiosInstance.post(
        '/api/mercadoPago/createPreference',
        {
          amount: amountParam,
          title: 'Carga de saldo $' + amountParam + ' en Casino Print($$$)',
          unit_price: amountParam,
          quantity: 1,
          description:
            'Carga de saldo $' + amountParam + ' en Casino Print($$$)',
          picture_url: `https://nicolasborghese.github.io/RepositorioDeImagenes/casino_print/fichasPoker/FichaPoker${amountParam}Resized.png`,
        }
      );

      const { id } = response.data;
      setPreferenceId(id);
    } catch (error) {
      // Error silencioso - la UI ya muestra estado de carga
    }
  };

  useEffect(() => {
    const createPreferenceOnce = async () => {
      if (hasAttemptedCreation.current) {
        return;
      }

      if (!userData) {
        return;
      }

      hasAttemptedCreation.current = true;

      try {
        const montoParam = parseFloat(params.get('monto'));
        setMonto(montoParam);

        await createPreference(montoParam);
      } catch (error) {
        hasAttemptedCreation.current = false;
      }
    };

    if (!isMercadoPagoInitialized.current) {
      initMercadoPago(process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY);
    }

    createPreferenceOnce();
  }, [userData]);

  useEffect(() => {
    if (!isLoading && !userData) {
      navigate(ROUTES.home);
    }
  }, [userData, isLoading, navigate]);

  const formatCurrency = (value) => {
    return value.toLocaleString('es-AR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div>
      <BannerFichas />
      <div className="bg-gradient-to-b from-slate-950 to-violet-950 min-h-screen">
        <Navbar />
        <SessionBar />

        {montoValido ? (
          <div className="flex flex-col flex-grow items-center justify-center text-center py-10 px-4">
            <h2 className="text-2xl text-yellow-500 font-bold mb-4">
              {t('selectPayment.title')}
            </h2>
            <p className="text-sm text-gray-300 mb-8">
              {t('selectPayment.subtitle')}
            </p>
            <div className="flex flex-col lg:flex-row gap-6 lg:space-x-10 w-full max-w-5xl justify-center">
              <div className="bg-bgContenedorOscuro border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-lg rounded-lg p-6 flex flex-col items-center w-full lg:w-auto">
                <p className="text-sm text-gray-300 mb-4 max-w-80">
                  {t('selectPayment.loadingAmount1')}
                </p>
                <h2 className="text-yellow-500 text-lg font-bold mb-2">
                  ${monto ? formatCurrency(monto) : '-'}
                </h2>
                <img
                  src={
                    ROUTES.rutaFichasPoker +
                    'FichaPoker' +
                    monto +
                    'Resized.png'
                  }
                  alt="Item"
                  className="w-40 lg:w-60 object-cover mb-4"
                />
              </div>

              <div className="bg-bgContenedorOscuro border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-lg rounded-lg p-6 flex flex-col items-center w-full lg:w-max">
                <h2 className="text-yellow-500 text-lg font-bold mb-2 max-w-80">
                  {t('selectPayment.availablePayments')}
                </h2>
                <p className="text-sm text-gray-300 mb-4 max-w-80">
                  {t('selectPayment.selectMethod')}
                </p>
                <div>
                  {preferenceId ? (
                    preferenceId && (
                      <Wallet
                        initialization={{
                          preferenceId: preferenceId,
                        }}
                        customization={{
                          texts: {
                            valueProp: 'smart_option',
                          },
                        }}
                      />
                    )
                  ) : (
                    <p className="text-lg text-gray-300 mb-4 max-w-80">
                      {t('selectPayment.loading')}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col flex-grow items-center justify-center text-center py-10">
            <h2 className="text-2xl text-yellow-500 font-bold mb-4">
              {t('selectPayment.unavailable')}
            </h2>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default EleccionCargaSaldo;
